import { InvestmentStage, type InvestmentStageType } from '@/api/investing/types';
import { getInvestmentStageLabel } from '@/pages/pipelines/common/utils/stage-presentation';

/**
 * `Amount confirmed` and `Consent given` replace the stage's own name so the board
 * calls the investor wizard's steps — Amount, Eligibility, Sign & Consent, Payment —
 * what the wizard calls them. The stage keys themselves are untouched.
 */
const BOARD_STAGE_LABELS: Partial<Record<InvestmentStageType, string>> = {
  [InvestmentStage.SubscriptionStarted]: 'Amount confirmed',
  [InvestmentStage.DataSubmissionAcknowledged]: 'Consent given',
};

export const getInvestingBoardStageLabel = (stage: string): string =>
  BOARD_STAGE_LABELS[stage as InvestmentStageType] ?? getInvestmentStageLabel(stage);
